import { Component, computed, inject, input } from '@angular/core';
import {
  CoreJssProxyModule,
  TextField,
  type ImageField,
  type LinkField,
  type RichTextField,
} from '@core/jss-proxy';
import { FieldService, GenericLinkDirective } from '@core/jss-utils';
import { ENVIRONMENT_CONFIG } from '@core/config-angular';
import { NgTemplateOutlet, NgClass } from '@angular/common';
import { TrackLinkDirective } from '@analytics/events';

export interface LogoItem {
  image: ImageField | undefined;
  link: LinkField | undefined;
}

@Component({
  selector: 'wl-logos-section',
  standalone: true,
  templateUrl: './logos-section.component.html',
  styleUrls: [
    './logos-section.component.ed.scss',
    './logos-section.component.essent.scss',
  ],
  imports: [
    CoreJssProxyModule,
    NgTemplateOutlet,
    GenericLinkDirective,
    TrackLinkDirective,
    NgClass,
  ],
})
export class LogosSectionComponent {
  readonly uid = input.required<string>();
  readonly title = input.required<TextField>();
  readonly introduction = input.required<RichTextField>();
  readonly logos = input.required<LogoItem[]>();

  readonly #brand = inject(ENVIRONMENT_CONFIG).brand;
  readonly #fieldService = inject(FieldService);

  readonly showIntroduction = computed(() =>
    this.#fieldService.showTextField(this.introduction())
  );

  readonly isEssent = computed(() => this.#brand === 'essent');

  readonly getLogoCols = computed(() => {
    const count = this.logos().length;

    // Map of number of logos → [MD columns, LG columns, XL columns]
    const defaultCols = [3, 4, 5];
    const customCols: Record<number, [number, number, number]> = {
      4: [4, 4, 4],
      5: [3, 5, 5],
      6: [3, 3, 6],
    };

    const [md, lg, xl] = customCols[count] ?? defaultCols;

    return [`row-cols-md-${md}`, `row-cols-lg-${lg}`, `row-cols-xl-${xl}`];
  });
}
